

















































































































































































































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, CheckBox, Select, Radio, DatePicker } from '@/components/form'
import { Select2 } from '@/components/general'

// models
import { PropOptionSelect } from '@/models'
import { EmployeeInsuranceModel, AfpModel, InsuranceCompany } from '@/models/config'

// services
import { AfpService, InsuranceCompanyService } from '@/services/config'

// constants
import { optionsTypeCommission, optionsSctrPension, optionsRegimes } from '@/constants'

@Component({
    name: 'InsuranceSectionForm',
    components: {
        Input,
        Select,
        CheckBox,
        Radio,
        DatePicker,
        Select2
    }
})
export default class InsuranceSectionForm extends Vue {
    @Prop({ type: Object, required: true }) insurance!: EmployeeInsuranceModel
    @Prop({ type: Object, default: () => ({}) }) validations!: {}

    opTypeCommission = optionsTypeCommission
    opSctrPension = optionsSctrPension
    optionsRegimes = optionsRegimes
    afpActivated: AfpModel[]|[] = []
    allInsuranceCompanies: InsuranceCompany[] = []

    mounted () {
        this.getAfpActivated()
        this.getInsuranceCompanies()
    }

    async getAfpActivated () {
        this.afpActivated = await AfpService.getActivated()
    }

    async getInsuranceCompanies () {
        this.allInsuranceCompanies = await InsuranceCompanyService.getActivated()
    }

    get opAfp (): PropOptionSelect[] {
        const optionsAfp: PropOptionSelect[] = []
        this.afpActivated.forEach(afp => {
            optionsAfp.push({
                text: afp.name,
                value: afp.id
            })
        })
        return optionsAfp
    }

    get opInsuranceCompanies (): PropOptionSelect[] {
        return this.allInsuranceCompanies.map(insurance => {
            return {
                value: insurance.id,
                text: insurance.name
            }
        })
    }
}
